<template>
  <div
    id="right-panel-filter-view"
    class="page"
    style="display: flex; flex-direction: column; top: 44px;">
    <f7-list
      id="filter-field"
      accordion
      media-list
      class="filterFontSize"
      style="flex: 0 1 auto">
      <!-- Filtre Identifiant du fournisseur -->
      <f7-list-item
        v-if="showFilterSupplierId() && LMSGsupplierconfig"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('filter.supplier_id') }}
        </span>
        <textarea
          slot="inner"
          v-model="filterSupplierId"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterSupplierId}"
          :placeholder="$t('filter.supplier_id')" />
      </f7-list-item>

      <!-- Filtre SIREN du fournisseur -->
      <f7-list-item
        v-if="showFilterSupplierSIREN()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('common.srn') }}
        </span>
        <textarea
          slot="inner"
          v-model="filterSiren"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterSiren}"
          :placeholder="$t('common.srn_placeholder_supplier')" />
      </f7-list-item>

      <!-- Filtre raison sociale du fournisseur -->
      <f7-list-item
        v-if="showFilterSupplierName()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('common.social_reason') }}</span>
        <textarea
          slot="inner"
          v-model="filterSupplierName"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterSupplierName}"
          :placeholder="$t('filter.social_reason_placeholder')" />
      </f7-list-item>

      <!-- Filtre statut -->
      <f7-list-item
        accordion-item
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
          <i
            id="status-chevron"
            class="fa-light fa-chevron-down"
            style="float:right" />
        </span>
        <span
          slot="inner"
          class="filter-item-content">
          <i
            v-if="statusDisplay.icon"
            :class="`icon ${statusDisplay.icon}`" />
          <span
            :class="{'filter-item-input-complete':statusDisplay.nb > 0}">
            {{ statusDisplay.label }}
          </span>
        </span>
        <f7-accordion-content>
          <f7-block>
            <span
              v-for="status in statusList"
              :key="status.name">
              <b-form-checkbox
                v-if="status.services.includes($engine.user.currentService.id)"
                v-model="status.state"
                :value="1"
                :unchecked-value="0">
                <i :class="`icon ${status.icon}`" />
                <span>{{ status.label }}</span>
              </b-form-checkbox>
            </span>
          </f7-block>
        </f7-accordion-content>
      </f7-list-item>

      <!-- Filtre date de début -->
      <f7-list-item
        v-if="showFilterDateBegin()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('common.date_start_label') }}
        </span>
        <input
          slot="inner"
          v-model="filterDateBegin"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterDateBegin}"
          type="date"
          :placeholder="$t('common.slct_date')">
      </f7-list-item>

      <!-- Filtre date de fin -->
      <f7-list-item
        v-if="showFilterDateEnd()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('common.date_end_label') }}
        </span>
        <input
          slot="inner"
          v-model="filterDateEnd"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterDateEnd}"
          type="date"
          :placeholder="$t('common.slct_date')">
      </f7-list-item>

      <!-- Filtre raison -->
      <f7-list-item
        v-if="showFilterReason()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('filter.reason') }}
        </span>
        <textarea
          slot="inner"
          v-model="filterReason"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterReason}"
          :placeholder="$t('filter.reason_placeholder')" />
      </f7-list-item>

      <!-- Filtre contact -->
      <f7-list-item
        v-if="showFilterContactName()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ $t('filter.cntct_name') }}
        </span>
        <textarea
          slot="inner"
          v-model="filterName"
          :class="{'filter-item-content': true, 'filter-item-input-complete': filterName}"
          :placeholder="$t('filter.cntct_name_placeholder')" />
      </f7-list-item>

      <!-- Filtre type d'action -->
      <f7-list-item
        v-if="showFilterTypeAction()"
        class="subitem">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ 'Type d\'action' }}
        </span>
        <span class="filter-item-content d-flex">
          <select
            ref="selectTypeAction"
            slot="inner"
            v-model="filterTypeAction"
            style="cursor:pointer;font-size:14px;height:auto;z-index:2;">
            <option disabled>Choisir une action</option>
            <option value="CREATE">{{ $t('history.CREATE') }}</option>
            <option value="DELETE">{{ $t('history.DELETE') }}</option>
            <option value="MODIFY">{{ $t('history.MODIFY') }}</option>
            <option value="SEND">{{ $t('history.SEND') }}</option>
            <option value="CANCEL">{{ $t('history.CANCEL') }}</option>
            <option value="ACCEPT">{{ $t('history.ACCEPT') }}</option>
            <option value="REFUSE">{{ $t('history.REFUSE') }}</option>
            <option value="MODIFY_AND_ACCEPT">{{ $t('history.MODIFY_AND_ACCEPT') }}</option>
            <option value="ACCEPT_AND_PAY">{{ $t('history.ACCEPT_AND_PAY') }}</option>
            <option value="PAY">{{ $t('history.PAY') }}</option>
          </select>
          <i
            id="status-chevron"
            class="fa-light fa-chevron-down"
            style="cursor:pointer;margin-left:-20px;z-index:1;" />
        </span>
      </f7-list-item>

      <!-- Filtre endToEndId -->
      <f7-list-item
        v-if="showFilterEndToEndId()"
        class="filter-item">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ 'End-To-End ID' }}
        </span>
        <textarea
          slot="inner"
          v-model="endToEndId"
          :class="{'filter-item-input': true, 'filter-item-input-complete': endToEndId}"
          :placeholder="'End-To-End ID'" />
      </f7-list-item>

      <!-- Filtre user -->
      <f7-list-item
        v-if="showFilterUser()"
        class="filter-item">
        <span
          slot="inner-start"
          class="filter-item-title">
          {{ 'Utilisateur' }}
        </span>
        <textarea
          slot="inner"
          v-model="user"
          :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
          :placeholder="'Saisir l\'identifiant'" />
      </f7-list-item>
    </f7-list>

    <div
      class="d-flex flex-column-reverse"
      style="flex: 1 1 auto; margin-bottom:20px">
      <f7-button
        :disabled="!hasDefaultFilter"
        class="button-round statusButton responsiveFilterButton"
        @click="deleteFilter()">
        {{ $t('filter.cln_fltr') }}
      </f7-button>
      <f7-button
        :disabled="!hasInputFilter"
        class="button-round statusButton responsiveFilterButton"
        @click="saveFilter()">
        {{ $t('filter.sv_fltr') }}
      </f7-button>
      <hr>
      <f7-button
        :disabled="!hasInputFilter"
        class="button-round statusButton responsiveFilterButton"
        @click="clearFilterFields()">
        {{ $t('filter.clr_fltr_field') }}
      </f7-button>
      <f7-button
        class="button-round statusButton responsiveFilterButton"
        @click="applyFilter()">
        {{ $t('filter.appl_fltr') }}
      </f7-button>
    </div>
  </div>
</template>

<script>
import Status from '@/helpers/status.js'
import {statusLabel, statusIcon} from '@/helpers/labels.js'
import services from '@/helpers/services.js'

export default {
  name: 'RightPanelFilterView',
  props: {
    isHistory: {
      type: Boolean,
      default: false
    },
    serviceId: {
      type: String,
      default: 'none'
    }
  },
  data () {
    return {
      hasDefaultFilter: '',
      filterDateBegin: '',
      filterDateEnd: '',
      filterReason: '',
      filterName: '',
      statusList: {
        statusWaiting: {
          label: statusLabel(this.$i18n, Status.WAITING),
          icon: statusIcon(Status.WAITING),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusExpired: {
          label: statusLabel(this.$i18n, Status.EXPIRED),
          icon: statusIcon(Status.EXPIRED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        // statusNegotiationRequest: {
        //   label: statusLabel(this.$i18n, Status.WAITING, '10'),
        //   icon: statusIcon(Status.WAITING, '10'),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusNegotiationResponse: {
        //   label: statusLabel(this.$i18n, Status.WAITING, '11'),
        //   icon: statusIcon(Status.WAITING, '11'),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        statusRequestReceived: {
          label: statusLabel(this.$i18n, Status.RECEIVED),
          icon: statusIcon(Status.RECEIVED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestAccepted: {
          label: statusLabel(this.$i18n, Status.ACCEPTED),
          icon: statusIcon(Status.ACCEPTED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestRevoked: {
          label: statusLabel(this.$i18n, Status.REVOKED),
          icon: statusIcon(Status.REVOKED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestModified: {
          label: statusLabel(this.$i18n, Status.MODIFIED),
          icon: statusIcon(Status.MODIFIED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusAcceptedAndPayed: {
          label: statusLabel(this.$i18n, Status.ACCEPTED_AND_PAYED),
          icon: statusIcon(Status.ACCEPTED_AND_PAYED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusAcceptedAndPayedInstant: {
          label: statusLabel(this.$i18n, Status.ACCEPTED_AND_PAYED_INST),
          icon: statusIcon(Status.ACCEPTED_AND_PAYED_INST),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusModifiedAndPayed: {
          label: statusLabel(this.$i18n, Status.MODIFIED_AND_PAYED),
          icon: statusIcon(Status.MODIFIED_AND_PAYED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusModifiedAndPayedInstant: {
          label: statusLabel(this.$i18n, Status.MODIFIED_AND_PAYED_INST),
          icon: statusIcon(Status.MODIFIED_AND_PAYED_INST),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCreditTransferGenerated: {
          label: statusLabel(this.$i18n, Status.ORDER_GENERATED),
          icon: statusIcon(Status.ORDER_GENERATED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusCreditTransferGeneratedInstant: {
          label: statusLabel(this.$i18n, Status.INST_ORDER_GENERATED),
          icon: statusIcon(Status.INST_ORDER_GENERATED),
          state: 0,
          filterName: 'list',
          services: ['1', '6']
        },
        statusBankStatementReceived: {
          label: statusLabel(this.$i18n, Status.MADE),
          icon: statusIcon(Status.MADE),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusBankStatementReceivedInstant: {
          label: statusLabel(this.$i18n, Status.INST_MADE),
          icon: statusIcon(Status.INST_MADE),
          state: 0,
          filterName: 'list',
          services: ['1', '6']
        },
        statusInstallmentPaid: {
          label: statusLabel(this.$i18n, Status.INSTALLMENT_PAID),
          icon: statusIcon(Status.INSTALLMENT_PAID),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCanceled: {
          label: statusLabel(this.$i18n, Status.CANCELED),
          icon: statusIcon(Status.CANCELED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusCanceledConfirm: {
          label: statusLabel(this.$i18n, Status.CANCELED_CONFIRM),
          icon: statusIcon(Status.CANCELED_CONFIRM),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusCanceledReject: {
          label: statusLabel(this.$i18n, Status.CANCELED_ABORT),
          icon: statusIcon(Status.CANCELED_ABORT),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRejected: {
          label: statusLabel(this.$i18n, Status.REJECTED),
          icon: statusIcon(Status.REJECTED),
          state: 0,
          filterName: 'list',
          services: ['1', '2']
        },
        statusInformation: {
          label: statusLabel(this.$i18n, Status.INFORMATION),
          icon: statusIcon(Status.INFORMATION),
          state: 0,
          filterName: 'list',
          services: ['6']
        },
        statusNotClosedFolder: {
          label: statusLabel(this.$i18n, Status.NOT_CLOSED_FOLDER),
          icon: statusIcon(Status.NOT_CLOSED_FOLDER),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusClosedFolder: {
          label: statusLabel(this.$i18n, Status.CLOSED_FOLDER),
          icon: statusIcon(Status.CLOSED_FOLDER),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusFolderContainingExpired: {
          label: statusLabel(this.$i18n, Status.FOLDER_CONTAINING_EXPIRED),
          icon: statusIcon(Status.FOLDER_CONTAINING_EXPIRED),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusFolderContainingRefused: {
          label: statusLabel(this.$i18n, Status.FOLDER_CONTAINING_REFUSED),
          icon: statusIcon(Status.FOLDER_CONTAINING_REFUSED),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusDocInitialized: {
          label: statusLabel(this.$i18n, Status.DOC_INITIALIZED),
          icon: statusIcon(Status.DOC_INITIALIZED),
          state: 0,
          filterName: 'details',
          services: ['8']
        },
        statusKYCwaiting: {
          label: statusLabel(this.$i18n, Status.NOT_CLOSED_PROVIDER),
          icon: statusIcon(Status.NOT_CLOSED_PROVIDER),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusKYCvalidated: {
          label: statusLabel(this.$i18n, Status.CLOSED_PROVIDER),
          icon: statusIcon(Status.CLOSED_PROVIDER),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusKYCrefused: {
          label: statusLabel(this.$i18n, Status.NOT_PAYABLE_PROVIDER),
          icon: statusIcon(Status.NOT_PAYABLE_PROVIDER),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusRequestSent: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_SENT),
          icon: statusIcon(Status.DOC_REQUEST_SENT),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestReceived: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_RECEIVED),
          icon: statusIcon(Status.DOC_REQUEST_RECEIVED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestRejected: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_REJECTED),
          icon: statusIcon(Status.DOC_REQUEST_REJECTED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestCanceled: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_CANCELED),
          icon: statusIcon(Status.DOC_REQUEST_CANCELED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestOutTime: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_OUT_TIME),
          icon: statusIcon(Status.DOC_REQUEST_OUT_TIME),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestAccepted: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_ACCEPTED),
          icon: statusIcon(Status.DOC_REQUEST_ACCEPTED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestRefused: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_REFUSED),
          icon: statusIcon(Status.DOC_REQUEST_REFUSED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocSent: {
          label: statusLabel(this.$i18n, Status.DOC_SENT),
          icon: statusIcon(Status.DOC_SENT),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocReceived: {
          label: statusLabel(this.$i18n, Status.DOC_RECEIVED),
          icon: statusIcon(Status.DOC_RECEIVED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRejected: {
          label: statusLabel(this.$i18n, Status.DOC_REJECTED),
          icon: statusIcon(Status.DOC_REJECTED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocValidated: {
          label: statusLabel(this.$i18n, Status.DOC_VALIDATED),
          icon: statusIcon(Status.DOC_VALIDATED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRefused: {
          label: statusLabel(this.$i18n, Status.DOC_REFUSED),
          icon: statusIcon(Status.DOC_REFUSED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocExpired: {
          label: statusLabel(this.$i18n, Status.DOC_EXPIRED),
          icon: statusIcon(Status.DOC_EXPIRED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDraftNeedCompleted: {
          label: statusLabel(this.$i18n, Status.DRAFT_NEED_COMPLETED),
          icon: statusIcon(Status.DRAFT_NEED_COMPLETED),
          state: 0,
          filterName: 'draft',
          services: ['6']
        },
        statusDraftWaitingValidation: {
          label: statusLabel(this.$i18n, Status.DRAFT_WAITING_VALIDATION),
          icon: statusIcon(Status.DRAFT_WAITING_VALIDATION),
          state: 0,
          filterName: 'draft',
          services: ['6']
        },
        statusDraftWaitingUpperValidation: {
          label: statusLabel(this.$i18n, Status.DRAFT_WAITING_UPPER_VALIDATION),
          icon: statusIcon(Status.DRAFT_WAITING_UPPER_VALIDATION),
          state: 0,
          filterName: 'draft',
          services: ['6']
        },
        statusDraftReadyToSend: {
          label: statusLabel(this.$i18n, Status.DRAFT_READY_TO_SEND),
          icon: statusIcon(Status.DRAFT_READY_TO_SEND),
          state: 0,
          filterName: 'draft',
          services: ['6']
        }
      },
      filterSupplierName: '',
      filterSupplierId: '',
      filterSiren: '',
      services: services,
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig
    }
  },
  computed: {
    filterFields () {
      let that = this
      let filter = {}

      // Date, Reason and Name values
      filter.filterDateBegin = this.filterDateBegin
      filter.filterDateEnd = this.filterDateEnd
      filter.filterReason = this.filterReason
      filter.filterName = this.filterName

      // Supplier social reason
      filter.filterSupplierName = this.filterSupplierName
      filter.filterSupplierId = this.filterSupplierId
      filter.filterSiren = this.filterSiren

      // Status values
      for (const property in this.statusList) {
        let status = that.statusList[property]
        filter[property] = status.state
      }

      return filter
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          tag: property,
          label: status.label,
          icon: status.icon,
          state: status.state
        })
      }
      return list
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(status => status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_status_many'),
          nb: realStatusList.length
        }
      }
    },
    hasInputFilter () {
      return this.statusDisplay.nb > 0 ||
             this.filterDateBegin ||
             this.filterDateEnd ||
             this.filterReason ||
             this.filterName ||
             this.filterSiren ||
             this.filterSupplierName ||
             this.filterSupplierId
    }
  },
  watch: {
    hasDefaultFilter: function () {
      this.communicateChange()
    },
    filterDateBegin: function () {
      this.communicateChange()
    },
    filterDateEnd: function () {
      this.communicateChange()
    },
    filterReason: function () {
      this.communicateChange()
    },
    filterName: function () {
      this.communicateChange()
    },
    filterSiren: function () {
      this.communicateChange()
    },
    filterSupplierName: function () {
      this.communicateChange()
    },
    filterSupplierId: function () {
      this.communicateChange()
    },
    statusList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  },
  created () {
    // Intercepts filter changes from the right-panel-filter-view
    this.$bus.on('right-panel-filter-view-update-fields', (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  methods: {
    communicateChange () {
      this.$bus.emit('filter-update-fields', this.filterFields)
    },
    applyFilter () {
      this.$bus.emit('filter-apply-filter')
      this.$bus.emit('right-panel-close')
    },
    clearFilterFields () {
      this.filterDateBegin = ''
      this.filterDateEnd = ''
      this.filterReason = ''
      this.filterName = ''
      this.filterSiren = ''
      this.filterSupplierName = ''
      this.filterSupplierId = ''
      for (const property in this.statusList) {
        this.statusList[property].state = 0
      }
      this.$bus.emit('filter-clear-filter-fields')
    },
    saveFilter () {
      this.$bus.emit('filter-save-filter')
    },
    deleteFilter () {
      this.$bus.emit('filter-delete-filter')
    },
    showFilterDateBegin () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterDateEnd () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterContactName () {
      if (((this.filterType === 'list' && this.serviceId !== '7' && this.serviceId !== '8') ||
          (this.filterType === 'details' && (this.serviceId === '7' || this.serviceId === '8') && this.mode !== 2) ||
          this.filterType === 'draft') &&
          !this.isHistory) {
        return true
      }
      return false
    },
    showFilterDoctype () {
      return this.mode === 2 &&
        this.serviceId === services.DOCUMENTSERVICE
    },
    showFilterEndToEndId () {
      return this.isHistory
    },
    showFilterReason () {
      return this.$engine.user.currentService.id !== '7' &&
        this.$engine.user.currentService.id !== '8' &&
        !this.isHistory
    },
    showFilterStatus () {
      return this.mode !== 2 &&
        !this.isHistory
    },
    showFilterSupplierId () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterSupplierName () {
      if ((this.filterType === 'list' && this.serviceId === services.SUPPLIERS) ||
        (this.filterType === 'details' && this.serviceId === services.DOCUMENTSERVICE && this.mode === 2)) {
        return true
      }
      return false
    },
    showFilterSupplierSIREN () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterTypeAction () {
      return this.isHistory
    },
    showFilterUser () {
      return this.isHistory
    },
    showListDraftPanel () {
      return this.serviceId === services.DIRECTPAYMENTS
    },
    showListGroupPanel () {
      return this.serviceId === services.PAYMENTS &&
        !this.isHistory
    },
    showStatus (status) {
      return status.services.includes(this.$engine.user.currentService.id) &&
        status.filterName === this.filterTypeGet
    }
  }
}
</script>

<style scoped>
#right-panel-filter-view {
  min-height: calc(100% - 44px);
}
li.subitem {
  background-color: rgb(250, 250, 250);
}
.filter-item-title {
  color: var(--actionButtonColor);
  font-weight: 700;
}
.filter-item-content, span.filter-item-content, input.filter-item-content, textarea.filter-item-content {
  font-size: inherit;
  line-height: inherit;
  color: #969696;
  padding: 0 0 0 0;
  height:auto;
}
input.filter-item-input-complete, span.filter-item-input-complete, textarea.filter-item-input-complete {
  color:#000;
}
textarea {
  max-height: 2.5rem;
}

#status-chevron {
  font-size: inherit;
  line-height: inherit;
  color:inherit;
}

.responsiveFilterButton { /* IRY 10/2020 Changement de la couleur d'accent (vert MoneyRoad)*/
  background-color: var(--actionButtonColor);
  border-color: transparent;
  margin-right: 10%;
  margin-left: 10%;
  margin-top: 15px;
}

hr {
  margin-bottom: 0px;
  margin-top: 15px;
  height: 1px;
  background-color: silver;
  border: none;
}

.icon {
  min-height: 20px;
  min-width: 20px;
}
</style>
